import(/* webpackMode: "eager" */ "C:\\var\\coverz_ui\\src\\app\\(home)\\layout.tsx");
